import React from "react";
import "./Header.css";
import Typical from "react-typical";
import profilePic from "../../../images/linkedin-profile.jpeg";

const Header = () => {
  return (
    <header>
      <div className="header container">
        <div className="banner ">
          <div className="banner-text">
            <div
              className="img-section"
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="0"
            >
              <div className="anim-container">
                <span className="anim"></span>
              </div>
              <img
                className="profile-img"
                src={profilePic}
                alt="Md Jahidul Islam profile"
              />
            </div>
            <h1
              className="headline text-center"
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="200"
            >
              <span> I'm a</span>
              <span className="animated-text">
                <Typical
                  loop={Infinity}
                  wraper=""
                  steps={[
                    " Jahidul Islam",
                    1000,
                    " Software Engineer 💻",
                    1000,
                    " Frontend Developer 💻",
                    1000,
                    " Backend Developer",
                    1000,
                    " Full-Stack Web Developer",
                    1000,
                    " MERN Stack Developer 💻",
                    1000,
                  ]}
                />
              </span>
            </h1>
            <div
              className="status"
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="200"
            >
              <ul>
                <li>
                  {" "}
                  <span>&bull;</span> Full Stack Web Developer{" "}
                </li>
                <li>
                  <span>&bull;</span> MERN Stack{" "}
                </li>
              </ul>
            </div>
            <h3 data-aos="fade-up" data-aos-offset="0" data-aos-delay="200">
              Experienced Full-Stack Web Developer with 3+ years designing and
              building responsive, high-performance websites and web
              applications using React, Node.js, Express.js, and MongoDB...
            </h3>

            <div
              className="social"
              style={{ display: "flex", justifyContent: "center" }}
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="400"
            >
              <div
                style={{ display: "flex", justifyContent: "center", width: "" }}
              >
                <ul class="menu" data-animation="to-top">
                  <li>
                    <a
                      href="https://github.com/jahid777"
                      target="blank"
                      class="bg1"
                    >
                      <span>
                        <i class="bi bi-github"></i>
                      </span>
                      <span class="bg2">
                        <i class="bi bi-github" aria-hidden="true"></i>
                      </span>
                    </a>
                  </li>
                </ul>

                <ul class="menu" data-animation="to-top">
                  <li>
                    <a
                      href="https://www.linkedin.com/in/md-jahidul-islam-9578941a6"
                      target="blank"
                      class="bg1"
                    >
                      <span>
                        <i class="bi bi-linkedin"></i>
                      </span>
                      <span class="bg2">
                        <i class="bi bi-linkedin" aria-hidden="true"></i>
                      </span>
                    </a>
                  </li>
                </ul>

                <ul class="menu" data-animation="to-top">
                  <li>
                    <a
                      href="mailto:za0162hid@gmail.com"
                      target="blank"
                      class="bg1"
                    >
                      <span>
                        <i class="bi bi-envelope"></i>
                      </span>
                      <span class="bg2">
                        <i class="bi bi-envelope" aria-hidden="true"></i>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
